import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';

import { basicMsg } from '../../../../actions/swal_msg';
import { deleteCategory, deleteSubcategory, saveSubcategory, updateImg } from '../../../../actions/category';

import { GOOGLE_DRIVE_CDN } from '../../../../constants/constants';

import {
    Stack, Typography, Grid, IconButton, ListItemIcon, Checkbox,
    TextField, Box, Chip, Alert, Divider, Tooltip, Menu, MenuItem
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadIcon from '@mui/icons-material/Upload';
import CancelIcon from '@mui/icons-material/Cancel';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import HideImageIcon from '@mui/icons-material/HideImage';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DragHandleIcon from '@mui/icons-material/DragHandle';

import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
});

const ProductCategoryList = ({ _category, categories, setCategories, setDeleted, index }) => {
    const dispatch = useDispatch();

    const { _id, checked, category, subcategories, imgFile, imgId } = _category;

    const [displayField, setDisplayField] = useState(false);
    const [fields, setFields] = useState({
        categoryField: '',
        subcategoryField: ''
    });
    const { categoryField, subcategoryField } = fields;

    const fileInputRef = useRef();

    useEffect(() => {
        setFields((e) => ({ ...e, categoryField: category }));
    }, [category]);

    // seleccionar categorías existentes
    const onChangeCheckbox = ({ target }) => {
        const checked = target.checked;
        if (!checked)
            setDeleted((e) => e.filter(e => e._id !== _id));
        else
            setDeleted((e => [...e, { _id, imgId, category }]));
        setCategories((e) => e.map(
            u => u._id === _id ?
                { ...u, checked } : u
        ));
    };

    // agregar subcategoría a categoría
    const addSubcategory = () => {
        if (subcategoryField.length > 2 && subcategoryField.length <= 60) {
            const subcategoryInArray = subcategories.find(
                e => e.toLowerCase() === subcategoryField.toLowerCase()
            );
            if (subcategoryInArray)
                basicMsg('La subcategoría ya está registrada');
            else
                dispatch(saveSubcategory({
                    _id, category, subcategory: subcategoryField
                }, setFields));
        }
    };

    // remueve subcategoría de categoría ya registrada
    const removeSubcategory = _subcategory => () => {
        dispatch(deleteSubcategory({
            _id, category, subcategory: _subcategory
        }));
    };

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'category' && value.length <= 60)
            setFields((e) => ({ ...e, categoryField: value.toUpperCase() }));
        else if (name === 'subcategory' && value.length <= 60)
            setFields((e) => ({ ...e, subcategoryField: value.toUpperCase() }));
    };

    const deleteCategoryFn = () => {
        setAnchorEl(null);
        Swal.fire({
            title: `¿Eliminar categoría '${category}'?`,
            showDenyButton: true,
            confirmButtonText: 'Eliminar',
            denyButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteCategory({ _id, imgId }, categories));
            }
        });
    };

    // mostrar campo de categoria
    const showField = () => {
        setDisplayField(!displayField);
    };

    const updateMainCategory = () => {
        if (categoryField.length > 2 && categoryField.length <= 60) {
            setCategories((e) => e.map(
                u => u._id === _id ?
                    { ...u, category: categoryField } : u
            ));
            setDisplayField(false);
        }
    };

    //Abrir y cerrar menu para eliminar la categoria
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // cambiar foto de categoría
    const changeImg = ({ target }) => {
        if (target.files.length > 0) {
            if (['image/jpeg', 'image/png', 'image/webp'].includes(target.files[0].type))
                setCategories((e) => e.map(
                    u => u._id === _id ?
                        { ...u, imgFile: target.files[0] } : u
                ));
            else basicMsg('Imagen no compatible');
        }
    };
    // quitar imagen recién subida (elegida de ordenador)
    const removeImg = () => {
        fileInputRef.current.value = '';
        setCategories((e) => e.map(
            u => u._id === _id ?
                { ...u, imgFile: '' } : u
        ));
    };
    // actualizar imagen de categoría
    const updateCategoryImg = () => {
        dispatch(updateImg({ _id, imgId, imgFile }));
    };

    return (
        <Draggable key={_id} draggableId={_id} index={index}>
            {(provided, snapshot) => (
                <Grid item xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} sx={{ display: 'flex' }}
                    ref={provided.innerRef}
                    {...provided.draggableProps}>
                    <Box className='card_admn_categories'>
                        <Box display='flex' justifyContent='flex-end' padding={1} gap='12px'>
                            <Box sx={{ my: 'auto' }}>
                                <Checkbox color="default" size='small'
                                    checked={checked}
                                    onChange={onChangeCheckbox} />
                            </Box>

                            <Box sx={{ my: 'auto' }}>
                                <IconButton size='small' onClick={handleClick}>
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={deleteCategoryFn}>
                                        <ListItemIcon>
                                            <DeleteIcon fontSize="small" />
                                        </ListItemIcon>
                                        Eliminar categoría
                                    </MenuItem>
                                </Menu>
                            </Box>

                            <Box sx={{ my: 'auto', mr: 1 }} {...provided.dragHandleProps}>
                                <DragHandleIcon sx={{color: 'rgba(0, 0, 0, 0.54)'}} />
                            </Box>
                        </Box>
                        <Divider />
                        <Box sx={{ p: 3 }}>
                            {
                                imgFile &&
                                <>
                                    <Tooltip title="Remover imagen">
                                        <IconButton aria-label="remove-img"
                                            size="small"
                                            onClick={removeImg}>
                                            <HideImageIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Actualizar imagen"
                                        size="small"
                                        onClick={updateCategoryImg}>
                                        <IconButton aria-label="update-img">
                                            <SaveIcon />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            }
                            <Box className='top_card_categories' mb={3}>
                                <Box sx={{ my: 'auto' }}>
                                    <img className='img_categories'
                                        src={
                                            imgFile instanceof File ?
                                                URL.createObjectURL(imgFile)
                                                :
                                                `${GOOGLE_DRIVE_CDN}${imgId}`
                                        }
                                        width='120px'
                                        style={{ borderRadius: '6px' }}
                                    />
                                    <Tooltip title="Subir imagen">
                                        <IconButton component="label">
                                            <UploadIcon fontSize="inherit" />
                                            <VisuallyHiddenInput
                                                ref={fileInputRef}
                                                accept="image/*" type="file"
                                                onChange={changeImg}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box className='name_content_categories' sx={{ my: 'auto' }}>
                                    {
                                        displayField ?
                                            <Stack
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="flex-start"
                                                spacing={1}>
                                                <TextField
                                                    name="category"
                                                    label="Categoría principal"
                                                    variant="outlined"
                                                    value={categoryField}
                                                    inputProps={{ maxLength: 60 }}
                                                    size="small"
                                                    onChange={handleInputChange} />
                                                <IconButton
                                                    onClick={() => { setDisplayField(false) }}>
                                                    <CancelIcon />
                                                </IconButton>
                                                <IconButton
                                                    onClick={updateMainCategory}>
                                                    <CheckCircleIcon />
                                                </IconButton>
                                            </Stack>
                                            :
                                            <Box className='categories_name' sx={{ display: 'flex', gap: '10px' }}>
                                                <Typography variant='h6' sx={{ my: 'auto' }}>
                                                    {category}
                                                </Typography>
                                                <Tooltip title="Editar nombre de categoría">
                                                    <IconButton sx={{ my: 'auto' }} onClick={showField} size='small'><EditIcon fontSize='small' /></IconButton>
                                                </Tooltip>
                                            </Box>
                                    }
                                </Box>

                            </Box>

                            <Typography variant="body1" gutterBottom>
                                Subcategorías:
                            </Typography>
                            <Box className='subcategories_admn_content' mb={3}>
                                {
                                    subcategories.length > 0
                                        ?
                                        <>
                                            {
                                                subcategories.map((value) => (
                                                    <Chip key={value} label={value} onDelete={removeSubcategory(value)}
                                                        sx={{ backgroundColor: '#85c1e9', color: '#fff', fontWeight: '600' }}
                                                    />
                                                ))
                                            }
                                        </>
                                        :
                                        <Alert severity="info" sx={{ width: '100%' }}>Ninguna subcategoria existente</Alert>
                                }
                            </Box>

                            <Box sx={{ display: 'flex', gap: '15px' }}>
                                <TextField className='add_subcategory_input' sx={{ width: '40%' }}
                                    name="subcategory"
                                    label="Subcategoría"
                                    variant="outlined"
                                    value={subcategoryField}
                                    inputProps={{ maxLength: 60 }}
                                    size="small"
                                    onChange={handleInputChange} />

                                <IconButton aria-label="add" onClick={addSubcategory}>
                                    <AddBoxIcon fontSize="inherit" />
                                </IconButton>
                            </Box>
                        </Box>

                    </Box>
                </Grid>
            )
            }
        </Draggable >
    );
};

export default ProductCategoryList;